"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddButton = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _hooks = require("../hooks");
var _logger = require("../logger");
var _FormattedMessage = require("./FormattedMessage");
var _icons = require("./icons");
var _jsxRuntime = require("react/jsx-runtime");
const zIndex = 2;
const StyledIconButton = (0, _mui.styled)(_components.IconButton)({
    position: 'absolute',
    right: 6,
    zIndex
});
const StyledButton = (0, _mui.styled)(_components.Button)({
    marginLeft: 20,
    zIndex
});
const AddButton = (param)=>{
    let { hasValue, isFocused, ...props } = param;
    const breakpointIndex = (0, _hooks.useBreakpointIndex)();
    const isIconButtonDisplayed = breakpointIndex === 0 && (hasValue || isFocused);
    const isAddButtonDisplayed = breakpointIndex > 0;
    (0, _logger.logDebug)('Rendering AddButton ...', {
        hasValue,
        isFocused,
        isIconButtonDisplayed,
        isAddButtonDisplayed
    });
    if (isIconButtonDisplayed) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledIconButton, {
            color: "primary",
            type: "submit",
            variant: "contained",
            ...props,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.AddToBasket, {
                fontSize: "small"
            })
        });
    }
    if (isAddButtonDisplayed) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
            fullWidth: true,
            maxWidth: "130px",
            color: "default",
            type: "submit",
            variant: "outlined",
            ...props,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                id: "add"
            })
        });
    }
    return null;
};
exports.AddButton = AddButton;
